'use client';

import { Button, Modal } from '@components/common';
import { useTranslation } from 'next-i18next';

interface SuspendConfirmationDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isConfirmLoading?: boolean;
  suspensionType?: 'passive' | 'archived';
}

export const SuspendConfirmationDialog = (
  props: SuspendConfirmationDialogProps,
) => {
  // Destructure props
  const {
    open, onConfirm, onCancel, isConfirmLoading, suspensionType,
  } = props;

  // Translation
  const { t } = useTranslation('common');

  return (
    <Modal isOpen={open} onClose={onCancel} size="sm">
      <Modal.Header onClose={onCancel}>
        <h5 className="text-xl">{t('global.action.confirm')}</h5>
      </Modal.Header>
      <Modal.Body>

        {suspensionType === 'archived' ? <p>{t('global.action.archive.details')}</p>
          : <p>{t('global.action.suspend.details')}</p>}

      </Modal.Body>
      <Modal.Footer className="flex justify-end gap-2">
        <Button onClick={onConfirm} color="light" isLoading={isConfirmLoading} disabled={isConfirmLoading}>
          {suspensionType === 'archived' ? t('global.action.archive')
            : t('global.action.suspend')}

        </Button>
        <Button onClick={onCancel} color="secondary">
          {t('global.action.cancel')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
